var Hangar = window.HangarAlpha.Components;

App.Views.Main = Backbone.View.extend({

  el: 'body',

  events: {
    'click .js-ContactLink': '_onClickContactLink',
    'click .js-ReadMore': '_onClickReadMore',
    'keydown': '_onKeyDown'
  },

  initialize: function () {
    this._getParams()
    this._initViews()
    
    /*Use cases only available for solutions pages*/
    if (this.$el.hasClass('js-Solutions')){
      this._initUseCases()
    }
  },

  _getParameterByName: function (name) {
    name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]")
    var regexS = "[\\?&]" + name + "=([^&#]*)"
    var regex = new RegExp(regexS)
    var results = regex.exec(window.location.search)
    if (results == null) {
      return ""
    } else {
      return decodeURIComponent(results[1].replace(/\+/g, " "))
    }
  },

  _addFormElem: function (paramName) {
    var paramValue = this._getParameterByName(paramName)

    docCookies.setItem(paramName, paramValue, Infinity, "/")
  },

  _getParams: function () {
    var utmParams = [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_content',
      'utm_term'
    ]

    for (var i = 0; i < utmParams.length; i++) {
      this._addFormElem(utmParams[i])
    }
  },

  _initViews: function () {
    this.navbar = new Hangar.Navbar();
    this.navbarFixed = new Hangar.NavbarFixed({
      el: this.$('.js-Navbar--fixed'),
      $header: this.$('.js-Header').get(0),
      after: true
    });

    this.dialog = new App.Views.Dialog();

    this._initScrollbars()

    this._initDropdowns();
    this._initTabPanes();
  },

  _initDropdowns: function () {
    _.each(this.$('.js-Dropdown'), function (el) {
      new Hangar.Dropdown({
        el: $(el)
      });
    });
  },

  _initUseCases: function () {
    var _this = this

    _.each(this.$('.js-useCase'), function (element) {
      var useCase = new App.Views.UseCase({
        el: $(element)
      })
    })
  },

  _initTabPanes: function(){
    var tabPanes1 = new App.Views.Tabpanes({
      el: this.$('.js-TabPanes--1')
    });
  },

  _initScrollbars: function () {
    var _this = this

    _.each(this.$('.js-Scrollbar'), function (el) {
      var scrollbar = new App.Views.Scrollbar({
        el: $(el)
      })
    })

    _.each(this.$('.js-ScrollbarY'), function (el) {
      var scrollbarY = new App.Views.ScrollbarY({
        el: $(el)
      })
    })
  },

  _onKeyDown: function (e) {
    switch (e.which) {
      // esc
      case 27 :
        this._closeContactDialog()
        this._closeDropdowns()
        break
    }
  },

  _closeContactDialog: function () {
    if(typeof this.dialog.close === "function")
    this.dialog.close()
  },

  _onClickContactLink: function (e) {
    var mobile = 700
    var width = $(window).width()

    if (width >= mobile) {
      e.preventDefault()

      this.dialog.open()
    }
  },

  _closeDropdowns: function () {
    this.trigger('closedropdowns')
  },

  _onClickReadMore: function (e) {
    e.preventDefault()

    var $target = $(e.target).closest('a')

    var href = $target.attr('href')
    var id_ = href.split('#/')[1]

    this._goTo(this.$('#' + id_), {
      margin: 0
    }, function () {
      if (history.pushState) {
        history.pushState(null, null, href)
      } else {
        window.location.hash = href
      }
    })
  },

  _goTo: function ($el, opt, callback) {
    if ($el) {
      var speed = (opt && opt.speed) || 150
      var delay = (opt && opt.delay) || 0
      var margin = (opt && opt.margin) || 0

      $('html, body').delay(delay).animate({scrollTop:$el.offset().top - margin}, speed)

      setTimeout(function () {
        if (callback) {
          callback()
        }
      }, delay)
    }
  }






})

$(function () {
  window.main = new App.Views.Main()
})
